import React, { createContext } from 'react'

import { AppConfigProps } from './AppConfig.types'

import ErrorBoundary from '../ErrorBoundary/ErrorBoundary'
import Themer from '../Themer/Themer'

const AppConfig: React.FC<AppConfigProps> = ({ themeMode, theme, height, children }) => {
    return (
        <ErrorBoundary>
            <Themer themeMode={themeMode} theme={theme}>
                {(themeContext) => {
                    const style = {
                        height,
                        // background: themeContext.theme.colors.background,
                    }

                    return (
                        <div
                            data-testid='AppConfig'
                            className={`r-relay-container r-theme-${themeContext.theme.mode.toLowerCase()}`}
                            style={style}
                        >
                            {themeContext.initialScreenSizeCalComplete ? children : null}
                        </div>
                    )
                }}
            </Themer>
        </ErrorBoundary>
    )
}

export default AppConfig
